export default {
    computed: {
        // 项目采购模式
        getProjectBuyList () {
            return [
                {
                    value: 0,
                    label: this.$t('erp.product.none', { defaultValue: '无' })
                },
                {
                    value: 1,
                    label: this.$t('erp.planparam.purchase_self', { defaultValue: '自采' })
                },
                {
                    value: 2,
                    label: this.$t('erp.planparam.operate_owner', { defaultValue: '代运营' })
                }
            ]
        },
        // 采购模式
        getBuyModeList () {
            return  [
                {
                    value: "payment",
                    label: this.$t('erp.planparam.purchase_self', { defaultValue: '自采' })
                },
                {
                    value: "unpayment",
                    label: this.$t('erp.planparam.operate_owner', { defaultValue: '代运营' })
                },
                {
                    value: "fk",
                    label: this.$t('erp.planparam.fk', { defaultValue: "金融代采" }),
                },
                {
                    value: "undefined",
                    label: this.$t('bi.work.task_category_other', { defaultValue: "其他" }),
                },
            ]
        },
        // 产品状态
        getProductStatusList () {
            return [
                {
                    value: 0,
                    label: this.$t('global.common.inactive', { defaultValue: '停用' })
                },
                {
                    value: 1,
                    label: this.$t('fbb.accountmanage.active', { defaultValue: '启用' })
                }
            ]
        },
        // 产品补货状态
        getReplenishmentStatus () {
            return [
                {
                    value: 1,
                    label: this.$t('erp.product_status.error', { defaultValue: '不再补货' })
                },
                {
                    value: 0,
                    label: this.$t('erp.product_status.normal', { defaultValue: '正常补货' })
                }
            ]
        },
        // 销售定位
        getSalesLocation () {
            return [
                {value: 0,label:this.$t('erp.product.none', { defaultValue: '无' })},
                {value: 1,label:'NEW'},
                {value: 2,label:'Core'},
                {value: 3,label:'Normal'},
                {value: 5,label:'Discontinued-w/ Inventory'},
                {value: 6,label:'Discontinued-w/o Inventory'},
            ]
        },
    }
}